const commissionReport = () =>
  import("@/views/analytics/commissionReports.vue");
const workReports = () =>
  import("@/views/analytics/workReports.vue");
const deliveryChargeReport = () =>
  import("@/views/analytics/deliveryChargeReports.vue");
const inventoryReport = () => import("@/views/analytics/inventoryReports.vue");
const invoiceReport = () => import("@/views/analytics/invoiceReports.vue");
const itemReport = () => import("@/views/analytics/itemReports.vue");
const orderReport = () => import("@/views/analytics/orderReports.vue");
const dailyRegistration = () =>
  import("@/views/analytics/dailyRegistration.vue");
const partnerReport = () => import("@/views/analytics/partnerReports.vue");
const paymentReport = () => import("@/views/analytics/paymentReports.vue");
const refundReport = () => import("@/views/analytics/refundReports.vue");
const returnReport = () => import("@/views/analytics/returnReports.vue");
const serviceRequestReport = () =>
  import("@/views/analytics/serviceRequestReports.vue");
const downloadHistory = () => import("@/views/analytics/downloadHistory.vue");

export default {
  path: "analytics",
  name: "BI & Analytics",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/analytics/commissionReport",
      meta: {
        label: "Commission Report",
        requiresAuth: true,
      },
      component: commissionReport,
    },
    {
      path: "/analytics/deliveryChargeReport",
      meta: {
        label: "Delivery Charge Report",
        requiresAuth: true,
      },
      component: deliveryChargeReport,
    },
    {
      path: "/analytics/inventoryReport",
      meta: {
        requiresAuth: true,
      },
      component: inventoryReport,
    },
    {
      path: "/analytics/invoiceReport",
      meta: {
        requiresAuth: true,
      },
      component: invoiceReport,
    },
    {
      path: "/analytics/itemReport",
      meta: {
        requiresAuth: true,
      },
      component: itemReport,
    },
    {
      path: "/analytics/orderReport",
      meta: {
        label: "Order Report",
        requiresAuth: true,
      },
      component: orderReport,
    },
    {
      path: "/analytics/dailyRegistration",
      meta: {
        label: "Daily Registration Report",
        requiresAuth: true,
      },
      component: dailyRegistration,
    },
    {
      path: "/analytics/partnerReport",
      meta: {
        label: "Partner Report",
        requiresAuth: true,
      },
      component: partnerReport,
    },
    {
      path: "/analytics/paymentReport",
      meta: {
        label: "Payment Report",
        requiresAuth: true,
      },
      component: paymentReport,
    },
    {
      path: "/analytics/refundReport",
      meta: {
        requiresAuth: true,
      },
      component: refundReport,
    },
    {
      path: "/analytics/returnReport",
      meta: {
        requiresAuth: true,
      },
      component: returnReport,
    },
    {
      path: "/analytics/serviceRequestReport",
      meta: {
        requiresAuth: true,
      },
      component: serviceRequestReport,
    },
    {
      path: "/analytics/history/:type",
      name: "history",
      meta: {
        requiresAuth: true,
      },
      component: downloadHistory,
    },
    {
      path: "/analytics/workReports",
      meta: {
        label: "Work Reports",
        requiresAuth: true,
      },
      component: workReports,
    },
  ],
};
